import React, { useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { Button } from 'components/Button';
import Model from '../../../../model';

import './index.sass';

const { block } = bem('repeat-button');
const RepeatButton = ({order}) => {

    const specId = order.data.specialist.id;
    const { openSpecialistOrderForm } = Model.modal;
    const clickHandler = useCallback(() => {
        openSpecialistOrderForm(specId);
    }, [specId])

    return (
        <div className={block()}>
            <Button mod={'transparent-gold'} onClick={clickHandler}>
                <Text>Повторить</Text>
            </Button>
        </div>
    )
}

export default RepeatButton;

